// src/main.js
import * as model from './model';
import * as service from './service';
import * as repository from './repository';
import * as component from './component';

// Make them globally available
window.BCS = {
  ...model,
  ...service,
  ...repository,
  ...component,
};
